//Messages for the user
export const MESSAGE_WIN = 'Word Found!';
export const MESSAGE_NOT_WORD = `Word Not Found, Try Again`;
export const MESSAGE_GAME_OVER = 'Game Over. The word was:';
export const MESSAGE_START = 'Guess A Word';
export const TITLE_MAIN = 'Wordle Clone';
//Color values
export const GREEN_COLOR = 'rgb(0, 128, 0)';
export const GREY_COLOR = 'rgb(19, 19, 19)';
export const WRONG_COLOR = 'rgb(39, 33, 33)';
export const YELLOW_COLOR = 'rgb(198, 162, 0)';
export const VIRTUAL_KEY_DEFAULT = 'rgb(100, 110, 110)';
export const WINNING_ARRAY_COLOR = [GREEN_COLOR, GREEN_COLOR, GREEN_COLOR, GREEN_COLOR, GREEN_COLOR];